import ImageQualityCoowner from "src/assets/images/quality-coowner.png";
import ImageQualityLandlord from "src/assets/images/quality-landlord.png";
import ImageQualityTenant from "src/assets/images/quality-tenant.png";
import { AccountQualityEnum, HolderPropertyEnum } from "src/graphql/generated/types";

export const AccountQualityLabels: { [key in AccountQualityEnum]: string } = {
  [AccountQualityEnum.CoOwner]: "Copropriétaire",
  [AccountQualityEnum.Landlord]: "Propriétaire bailleur",
  [AccountQualityEnum.Tenant]: "Locataire",
};

export const AccountQualityLabelsShort: { [key in AccountQualityEnum]: string } = {
  [AccountQualityEnum.CoOwner]: "Copropriétaire",
  [AccountQualityEnum.Landlord]: "Bailleur",
  [AccountQualityEnum.Tenant]: "Locataire",
};

export const AccountQualityImageSource: { [key in AccountQualityEnum]: any } = {
  [AccountQualityEnum.CoOwner]: ImageQualityCoowner,
  [AccountQualityEnum.Landlord]: ImageQualityLandlord,
  [AccountQualityEnum.Tenant]: ImageQualityTenant,
};

// SRC: https://gitlab.factory.fonciamillenium.net/FonciaStark/front/-/blob/develop/packages/transformers/src/constants/accounts.js
export const HolderPropertyLabels: { [key in HolderPropertyEnum]: string } = {
  [HolderPropertyEnum.FullOwnership]: "Copropriétaire",
  [HolderPropertyEnum.NakedOwner]: "Nu-propriétaire",
  [HolderPropertyEnum.Usufructuary]: "Usufruitier",
  /** For now we will use the same label as the full ownership since Millenium do not handle this quality concept coming from EXTERNAL_GROWTH and THETRAWIN */
  [HolderPropertyEnum.MergedJointOwner]: "Copropriétaire",
  [HolderPropertyEnum.JointOwner]: "Indivisaire",
  [HolderPropertyEnum.JointOwnershipAccount]: "Compte de l'indivision",
};

export const RestrictedAccountMessage: { [key in AccountQualityEnum]: string } = {
  [AccountQualityEnum.Landlord]:
    "Suite à la fin de votre mandat de gestion, nous vous informons que vous aurez désormais un accès limité à votre espace client.",
  [AccountQualityEnum.CoOwner]:
    "Suite à la fin de votre engagement contractuel, nous vous informons que vous aurez désormais un accès limité à votre espace client.",
  [AccountQualityEnum.Tenant]:
    "Suite à la fin de votre contrat de bail, nous vous informons que vous aurez désormais un accès limité à votre espace client.",
};

export const DOUBLE_VERIFICATION_ERROR =
  "Erreur de paramètre, si vous avez copié le lien depuis l'e-mail reçu, veuillez vérifier à bien copier l'intégralité de l'adresse";

export const TWO_FACTOR_CODE_VALIDATION_ERROR = "Code incorrect";
